module.exports = __webpack_public_path__ + "img/tag9.718088c8.png";